<template>
  <button class="filter-btn" :class="{cancel}">
    <slot />
  </button>
</template>

<script>
export default {
  name: "Filter-btn",
  props: {
    cancel: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<style>
.filter-btn {
  font-family: inherit;
  outline: none;
  border: none;
  background: var(--color-green);
  color: var(--color-white);
  padding: 0.6rem 1.4rem;
  cursor: pointer;
  border-radius: 0.2rem;
  margin-right: 2rem;
  font-size: 1em;
  align-self: flex-end;
}

.filter-btn.cancel {
  background: transparent;
  color: inherit;
  border: 1px solid var(--color-grey);
}
</style>